import React, { ReactNode } from "react";
import LockIcon from "../icons/LockIcon";

import { Badge, FormLabelProps, Box, HStack } from "@chakra-ui/react";

export type FormLabelBadgePosition = "before" | "after";

const FormLabel = ({
  children,
  required = false,
  showNotRequired = false,
  htmlFor = "",
  unpublished = false,
  badgePosition = "after",
  hangingIndent = false,
  notRequiredBadgeBg = "gray.100",
  ...props
}: {
  children: ReactNode;
  required?: boolean;
  showNotRequired?: boolean;
  htmlFor?: string;
  unpublished?: boolean;
  badgePosition?: FormLabelBadgePosition;
  /** badgePosition="before" のとき、折り返したラベルをバッジの下に回り込ませずバッジの右側で揃える */
  hangingIndent?: boolean;
  notRequiredBadgeBg?: string;
} & FormLabelProps) => {
  const badge = required ? (
    <Badge background="caution" color="#FFF" fontSize="0.6875rem" mb={0.5} pt={"1px"}>
      必須
    </Badge>
  ) : showNotRequired ? (
    <Badge background={notRequiredBadgeBg} color="gray.700" fontSize="0.6875rem" mb={0.5} pt={"1px"}>
      任意
    </Badge>
  ) : null;

  return (
    <Box
      as="label"
      alignItems="center"
      gap={1}
      fontSize={{ base: "sm", sm: "md" }}
      fontWeight="600"
      htmlFor={htmlFor}
      display="inline-block"
      {...props}
    >
      <HStack gap={0} wrap={hangingIndent ? "nowrap" : "wrap"} align={hangingIndent ? "flex-start" : "center"}>
        {badge && badgePosition === "before" && (
          <Box mr={1} flexShrink={hangingIndent ? 0 : undefined}>
            {badge}
          </Box>
        )}
        <Box
          mr={(badge && badgePosition === "after") || unpublished ? 1 : 0}
          flex={hangingIndent ? "1 0 0" : undefined}
          minW={hangingIndent ? 0 : undefined}
        >
          {children}
        </Box>
        {badge && badgePosition === "after" && <Box mr={2}>{badge}</Box>}
        {unpublished && (
          <HStack color="textGray" gap={0} mb={0.5}>
            <LockIcon />
            <Box as="span" fontSize="xs" fontWeight="normal" mt={1}>
              この情報は公開されません
            </Box>
          </HStack>
        )}
      </HStack>
    </Box>
  );
};

export default FormLabel;
